import { useEffect } from 'react';

var useOuterClickNotifier = function useOuterClickNotifier(onOuterClick, innerRef) {
  useEffect(function () {
    function handleMouseDown(e) {
      var target = e.target;
      var refEl = innerRef.current;
      if (refEl && target instanceof Node && !refEl.contains(target)) {
        onOuterClick(e);
      }
    }
    if (innerRef.current) {
      document.addEventListener('mousedown', handleMouseDown);
    }
    return function () {
      return document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [onOuterClick, innerRef]);
};

export { useOuterClickNotifier };
